import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function NotFound() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoHome = () => {
    if (!user) navigate("/");
    else if (user.role === "barber") navigate("/dashboard");
    else navigate("/shops");
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        <div style={styles.errorCode}>404</div>
        <div style={styles.emoji}>✂️</div>

        <h1 style={styles.title}>Page Not Found!</h1>
        <p style={styles.subtitle}>
          Oops! Looks like this page got a bad haircut.
          We couldn't find what you were looking for.
        </p>

        <div style={styles.divider} />

        <p style={styles.suggestTitle}>You might be looking for:</p>

        <div style={styles.suggestions}>

          {/* ── Not logged in ── */}
          {!user && (
            <>
              <button onClick={() => navigate("/shops")} style={styles.suggestionBtn}>
                🏪 Browse Salons
              </button>
              <button onClick={() => navigate("/login")} style={styles.suggestionBtn}>
                🔑 Login
              </button>
              <button onClick={() => navigate("/register")} style={styles.suggestionBtn}>
                📝 Register
              </button>
            </>
          )}

          {/* ── Customer ── */}
          {user?.role === "customer" && (
            <>
              <button onClick={() => navigate("/shops")} style={styles.suggestionBtn}>
                🏪 Browse Salons
              </button>
              <button onClick={() => navigate("/my-bookings")} style={styles.suggestionBtn}>
                📅 My Bookings
              </button>
            </>
          )}

          {/* ── Barber ── */}
          {user?.role === "barber" && (
            <>
              <button onClick={() => navigate("/dashboard")} style={styles.suggestionBtn}>
                📊 My Dashboard
              </button>
              <button onClick={() => navigate("/coupons")} style={styles.suggestionBtn}>
                🎟️ My Coupons
              </button>
            </>
          )}

        </div>

        <button onClick={handleGoHome} style={styles.homeBtn}>
          ← Go Back Home
        </button>

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "var(--bg-primary)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  card: {
    background: "var(--bg-card)",
    borderRadius: "20px",
    padding: "40px 32px",
    maxWidth: "480px",
    width: "100%",
    textAlign: "center",
    border: "1px solid var(--border)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
  },
  errorCode: {
    fontSize: "clamp(5rem, 20vw, 8rem)",
    fontWeight: "900",
    background: "linear-gradient(135deg, var(--accent), #ff6b6b)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    lineHeight: 1,
    marginBottom: "8px",
  },
  emoji: { fontSize: "48px", marginBottom: "16px" },
  title: { fontSize: "1.6rem", fontWeight: "800", color: "white", marginBottom: "12px" },
  subtitle: { color: "var(--text-muted)", fontSize: "14px", lineHeight: 1.6, marginBottom: "24px" },
  divider: { height: "1px", background: "var(--border)", marginBottom: "24px" },
  suggestTitle: { color: "var(--text-secondary)", fontSize: "13px", marginBottom: "14px", fontWeight: "500" },
  suggestions: { display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center", marginBottom: "24px" },
  suggestionBtn: {
    background: "var(--bg-secondary)",
    border: "1px solid var(--border)",
    color: "var(--text-secondary)",
    padding: "9px 16px",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
  },
  homeBtn: {
    background: "var(--accent)",
    color: "white",
    border: "none",
    padding: "13px 32px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: "bold",
    width: "100%",
  },
};